import type { InputHTMLAttributes } from 'react';

/** The login and upload screens use identical input styling — one component. */
export function TextField(props: InputHTMLAttributes<HTMLInputElement>) {
  const { className, ...rest } = props;
  return <input {...rest} className={className ? `text-field ${className}` : 'text-field'} />;
}
